import { DeleteOutlined } from '@ant-design/icons';
import { Popconfirm } from 'antd';
import React from 'react';
import { Props } from '.';
import Icon from '../../../../components/icon/Icon';
import { EventVm, TimeoutRequest, UpdateEventCommand } from '../../../../utils/api';

class Timeout extends React.PureComponent<Props> {
    public setTeam = (teamId: number): void => {
        const { event, updateEvent, match } = this.props;

        if (!match?.homeTeamId || !match?.awayTeamId || !event.timeout) {
            return;
        }

        const eventVm = event as EventVm;
        const timeoutId =
            event.timeout.id !== undefined && event.timeout.id !== null
                ? event.timeout.id
                : eventVm.timeoutId ?? 0;

        const updatedEvent = new UpdateEventCommand({
            ...event,
            timeout: new TimeoutRequest({
                id: timeoutId,
                teamId,
            }),
        });

        updatedEvent.id = event.id;

        updateEvent(updatedEvent);
    };

    public render = (): React.ReactElement => {
        const { event, match, clearEvent, deleteEvent } = this.props;
        const eventVm = event as EventVm;
        const eventExists = !!eventVm.id;

        const homeId = match?.homeTeamId;
        const awayId = match?.awayTeamId;
        const teamId = event.timeout?.teamId;
        const isHomeTeam = homeId != null && teamId === homeId;
        const isAwayTeam = awayId != null && teamId === awayId;

        const pill = (label: string, active: boolean, onClick: () => void): React.ReactElement => (
            <span
                className={`c-shot-pill${active ? ' c-shot-pill--active' : ''}`}
                onClick={onClick}
                role="button"
            >
                {label}
            </span>
        );

        return (
            <div className="event-create">
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'flex-start',
                        marginBottom: 8,
                    }}
                >
                    <div className="title" style={{ fontSize: 16 }}>
                        Timeout —{' '}
                        {isHomeTeam ? 'home team' : isAwayTeam ? 'away team' : 'select team'}
                    </div>
                    <div className="c-shot-form__actions">
                        <span
                            className="c-shot-form__action-btn"
                            onClick={(): void => clearEvent()}
                            role="button"
                            title="Close"
                        >
                            <Icon name="icon-times" />
                        </span>
                        {eventExists && (
                            <Popconfirm
                                title="Are you sure you want to delete this event?"
                                onConfirm={(): void => deleteEvent(eventVm)}
                                okText="Delete"
                                okButtonProps={{ danger: true }}
                                cancelText="Cancel"
                            >
                                <span
                                    className="c-shot-form__action-btn c-shot-form__action-btn--delete"
                                    role="button"
                                    title="Delete"
                                >
                                    <DeleteOutlined />
                                </span>
                            </Popconfirm>
                        )}
                    </div>
                </div>
                {homeId != null && awayId != null && (
                    <div className="c-shot-form__grid">
                        <div className="c-shot-form__col" style={{ flexDirection: 'row', gap: 8 }}>
                            {pill('Home team', isHomeTeam, (): void => this.setTeam(homeId))}
                            {pill('Away team', isAwayTeam, (): void => this.setTeam(awayId))}
                        </div>
                    </div>
                )}
            </div>
        );
    };
}

export default Timeout;
